// ISO22000FSMSCertification.jsx
import React from "react";

export default function ISO22000FSMSCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 22000 FSMS
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 22000 Food Safety Management Certification Support
          </h1>
          <div className="w-20 h-1 bg-orange-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports ISO 22000 FSMS Certification for food
            safety management, helping organisations design and implement a food
            safety management system that meets ISO 22000:2018 requirements.[web:365][web:371]
          </p>
          <p className="text-gray-700">
            The service focuses on integrating HACCP principles, prerequisite
            programmes and management system controls so food safety hazards are
            identified, assessed and kept under control across the food
            chain.[web:363][web:370]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-orange-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3731474/pexels-photo-3731474.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Food production line symbolising food safety management"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 22000 FSMS Certification
            </h2>
            <p className="text-gray-700 mb-4">
              ISO 22000 requires defined food safety policy, hazard controls and
              documented information that shows how food safety risks are
              managed in practice.[web:363][web:371]
            </p>
            <div className="bg-gray-50 border border-orange-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Food safety manuals or FSMS manual describing the food safety
                  policy, scope, processes, HACCP approach and interaction of
                  system elements.[web:363][web:370]
                </li>
                <li>
                  Process flow charts and hazard analysis documents showing each
                  step of the food process, identified hazards, CCPs/OPRPs and
                  linked control measures.[web:363][web:366]
                </li>
                <li>
                  Company details and FSMS context information, including
                  organisational structure, activities, products, regulatory
                  requirements and interested parties.[web:364][web:371]
                </li>
                <li>
                  Records for monitoring, verification and improvements, such as
                  CCP/OPRP logs, verification results, internal audits and
                  corrective actions.[web:363][web:367]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The aim is to build a robust, audit‑ready FSMS that genuinely
              improves food safety while meeting certification requirements.[web:364][web:371]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-orange-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Food Safety Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on applying ISO 22000 with HACCP and prerequisite
                  programmes so that hazards are systematically controlled from
                  raw material to finished product.[web:363][web:370]
                </p>
              </div>

              <div className="border-l-4 border-orange-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in structuring documentation and records to match what
                  auditors expect for ISO 22000 stage 1 and stage 2
                  assessments.[web:364][web:367]
                </p>
              </div>

              <div className="border-l-4 border-orange-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory through implementation, internal audits,
                  certification audits and surveillance, helping maintain FSMS
                  effectiveness over time.[web:367][web:369]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-orange-500 text-orange-600 font-medium hover:bg-orange-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
